<template>
  <img
    v-if="brokerLogo"
    class="mx-auto my-8 hidden h-11 w-auto md:block"
    :src="brokerLogo"
    alt="broker logo"
  />
  <layout class="mt-6">
    <h1 class="header-text text-center">Sorry.</h1>
    <p class="mb-4 text-dark-gray">
      {{ brokerName }} only accepts connections with carriers it invited to
      connect. If you believe this is a mistake, please contact
      {{ brokerName }} directly.
    </p>
    <button-main @click="navigate">
      {{ linkText }}
      <img
        style="bottom: 2px"
        class="relative inline"
        src="@/assets/link-icon.svg"
        alt="Link icon"
      />
    </button-main>
  </layout>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import Layout from '@/components/layouts/HoldingTankLayout.vue';
import ButtonMain from '@/components/Button.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'CarrierInviteOnly',
  components: { ButtonMain, Layout },
  setup() {
    const store = useStore();
    const router = useRouter();
    const brokerLogo = ref(null);
    const brokerName = ref('');

    const companyType = computed(
      () => store.state.users.currentUser?.company?.company_type
    );

    const navigationData = computed(() => {
      const text =
        companyType.value === 'carrier'
          ? 'Go to Carrier Portal'
          : 'Go to Dispatch Service Portal';
      const route =
        companyType.value === 'carrier' ? '/carrier/brokers' : '/dispatcher';
      return { text, route };
    });

    onMounted(async () => {
      const publicDetails = await store.dispatch(
        'brokers/getLogoByClientId',
        localStorage.getItem('client_id')
      );
      if (publicDetails.status === 200) {
        brokerLogo.value = publicDetails?.data?.url;
        brokerName.value = publicDetails?.data?.legal_name;
      }
    });

    const navigate = () => {
      router.push(navigationData.value.route);
    };

    return {
      brokerLogo,
      linkText: navigationData.value.text,
      navigate,
      brokerName,
    };
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
